import { BIModel } from './BIModel';

// Common events (bi.js):
// - products
// - count
// - current_url
// - referrer_url
// - grid_view
// - is_seller
// - page

// Sections profile, home, feed, collections
// - flow
// - total

// Section filters
// - page
// - query
// - category_filter
// - brand_filter
// - status_filter
// - color_filter
// - size_filter
// - max_price_filter
// - min_price_filter
// - sort

export class ProductListBIModel extends BIModel {

    static eventName = 'product_list';

    #count;
    #currentUrl;
    #gridView;
    #isSeller;
    #page;
    #products;
    #timestamps;
    #labels;
    #referrerUrl;
    #flow;
    #total;
    #brandFilter;
    #categoryFilter;
    #colorFilter;
    #maxPriceFilter;
    #minPriceFilter;
    #query;
    #sizeFilter;
    #sort;
    #statusFilter;
    #sectionName;
    #countriesSeller;

    constructor(
        userId,
        count,
        currentUrl,
        gridView,
        isSeller,
        page,
        products,
        timestamps,
        labels,
        referrerUrl,
        flow,
        total,
        brandFilter,
        categoryFilter,
        colorFilter,
        maxPriceFilter,
        minPriceFilter,
        query,
        sizeFilter,
        sort,
        statusFilter,
        sectionName,
        countriesSeller
    ) {
        super(ProductListBIModel.eventName, userId);
        this.#count = count;
        this.#currentUrl = currentUrl;
        this.#gridView = gridView;
        this.#isSeller = isSeller;
        this.#page = page;
        this.#products = products;
        this.#timestamps = timestamps;
        this.#labels = labels;
        this.#referrerUrl = referrerUrl;
        this.#flow = flow;
        this.#total = total;
        this.#brandFilter = brandFilter;
        this.#categoryFilter = categoryFilter;
        this.#colorFilter = colorFilter;
        this.#maxPriceFilter = maxPriceFilter;
        this.#minPriceFilter = minPriceFilter;
        this.#query = query;
        this.#sizeFilter = sizeFilter;
        this.#sort = sort;
        this.#statusFilter = statusFilter;
        this.#sectionName = sectionName;
        this.#countriesSeller = countriesSeller;
    }

    get modelData() {
        return {
            count: this.#count,
            current_url: this.#currentUrl,
            grid_view: this.#gridView,
            is_seller: this.#isSeller,
            page: this.#page,
            products: this.#products,
            timestamps: this.#timestamps,
            labels: this.#labels,
            referrer_url: this.#referrerUrl,
            flow: this.#flow,
            total: this.#total,
            brand_filter: this.#brandFilter,
            category_filter: this.#categoryFilter,
            color_filter: this.#colorFilter,
            max_price_filter: this.#maxPriceFilter,
            min_price_filter: this.#minPriceFilter,
            query: this.#query,
            size_filter: this.#sizeFilter,
            sort: this.#sort,
            status_filter: this.#statusFilter,
            section_name: this.#sectionName,
            countries_seller: this.#countriesSeller
        };
    }

}